<template>
    <VContent>
        <VContainer fill-height>
            <VLayout
                    style="{max-width:500px;}"
                    align-content-center
                    mx-auto
                    wrap
            >
                <VFlex xs12 sm8 offset-sm2 md5 offset-md4>
                    <BaseCard v-if="code">
                        <VCardTitle>
                            Confirming
                        </VCardTitle>
                        <VCardText
                                pa-0
                                grid-list-xl
                        >
                            <VLayout wrap>
                                <VFlex xs12 class="text-center">
                                    <v-progress-circular
                                            v-if="isLoading"
                                            :size="100"
                                            color="primary"
                                            indeterminate
                                    ></v-progress-circular>
                                    <p v-else-if="!confirmed">
                                        Something went wrong
                                    </p>
                                    <span class="pl-3" v-else>
                                        <h2 class="teal--text">Confirmed</h2>

                                    </span>
                                </VFlex>

                            </VLayout>

                            <VLayout wrap>
                                <VFlex xs12>
                                    <p class="text-center my-2 pa-4" >
                                        <BaseBtn text  to="/auth/signin">
                                            Home
                                        </BaseBtn>
                                    </p>
                                </VFlex>
                            </VLayout>

                        </VCardText>

                    </BaseCard>
                    <BaseCard v-else>
                        <VCardTitle>
                            <span class="headline py-2 my-4">
                                <v-avatar tile size="40">
                                  <img src="/img/icons/apple-touch-icon-60x60.png" />
                                </v-avatar>
                                <span class="pl-3">
                                  Waiting Confirm
                                </span>
                            </span>
                        </VCardTitle>
                        <VCardText>
                            <h2>
                                Check email to confirm<br/> <span class="subtitle-2">Check your spam folder too :-)</span>
                            </h2>
                        </VCardText>
                        <VCardActions>
                            <BaseBtn to="/">Home</BaseBtn>
                        </VCardActions>
                    </BaseCard>
                </VFlex>
            </VLayout>
        </VContainer>
    </VContent>
</template>

<script>
  // Utilities
  import {
    mapActions,
    mapMutations
  } from 'vuex'
  import BaseBtn from "../../components/BaseBtn";

  export default {
    components: {BaseBtn},
    data () {
      const data = {
        isLoading: true,
        form: false,
        form2:false,
        firstName: undefined,
        lastName: undefined,
        email: undefined,
        username: undefined,
        password: undefined,
        confirmpassword: undefined,
        code: undefined,
        show: false,
        showConfirm: false,
        enterCode: true,
        confirmed:false
      }
      return data
    },
    watch: {
      isReady (val) {
        console.log('is ready: ', val)
        console.log('logged in', this.isLoggedIn)
        if (val && this.isLoggedIn) {
          let em = this
          setTimeout(function () {
            em.$router.push('/authenticated')
          }, 200)
        }
      }
    },
    mounted () {
      let em = this;
      let un = window.localStorage.getItem('username');
      if(un){
          em.username = un
      }
      if(this.$route.query.code && this.$route.query.username){
        this.code = this.$route.query.code
        this.username = this.$route.query.username
        this.confirm();
      } else {
        //this.$router.push('/auth/signup')
      }
    },
    methods: {
      ...mapActions('cognito', ['registerUser', 'confirmUser']),
      ...mapMutations(['setSnackbar']),
      confirm () {
        let em = this
        this.isLoading = true
        this.confirmUser({
            username: this.username.trim(),
            code: this.code.trim()
        }).then(() => {
          em.confirmed=true
          window.localStorage.setItem('username',this.username.trim())
          this.setSnackbar({
            type: 'success',
            msg: 'Account confirmed'
          })
          setTimeout(function(){
            em.$router.push('/auth/signin')
          },2000)

          })
          .catch(err => {
            this.setSnackbar({
              type: 'error',
              msg: err.message,
              timeout: 10000
            })
          })
          .finally(() => (this.isLoading = false))
      }
    }
  }
</script>
